<article class="grid-wrapper">
  <ng-template #statusCell let-license>
    @if (isActive(license)) {
    <span class="badge rounded-pill text-bg-success">{{ 'common.status.active' | translate }}</span>
    } @else {
    <span class="badge rounded-pill text-bg-secondary">{{ 'common.status.inactive' | translate }}</span>
    }
  </ng-template>
  @if (loading()) {
  <div class="state-row">
    <div class="spinner-wrapper">
      <app-spinner size="m" type="ripple" />
      <p>{{ 'pages.licenses.states.loading' | translate }}</p>
    </div>
  </div>
  } @else if (licenses().length === 0) {
  <div class="state-row">
    <span>{{ 'pages.licenses.states.empty' | translate }}</span>
  </div>
  } @else {
  <app-responsive-table
    [items]="licenses()"
    [columns]="columns()"
    [actions]="actions()"
    [maxInlineActions]="3"
    [trackBy]="trackByLicense"
    (actionSelected)="onActionSelected($event)"
    [paginated]="true"
    [page]="pageNumber()"
    [pageSize]="pageSize()"
    [totalItems]="totalItems()"
    (pageChange)="onPageChange($event)"
  />
  }
</article>
